import { render, staticRenderFns } from "./BudgetSelect.vue?vue&type=template&id=84cbc2aa&scoped=true&"
import script from "./BudgetSelect.vue?vue&type=script&lang=js&"
export * from "./BudgetSelect.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSelect.vue?vue&type=style&index=0&id=84cbc2aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cbc2aa",
  null
  
)

export default component.exports